import Vue from 'vue'
import store from '../vuex'

//地址
Vue.filter('codeFilter', code => {
  let returnValue = ''
  store.state.common.addressOld.map(item => {
    if (item.id == code) {
      returnValue = item.name
    }
  })
  return returnValue
})

//课程类目
Vue.filter('cateFilter', id => {
  let returnValue = ''
  let _funCate = function (tempList, id) {
    if (tempList.length == 0 || !id) return
    tempList.map(item => {
      if (item.id == id) {
        returnValue = item.name
        return
      }
      if (item.children) {
        _funCate(item.children, id)
      }
    })
  }
  _funCate(store.state.common.courseCateLevel, id)
  return returnValue
})

//年级范围
Vue.filter('gradeScopeFilter', code => {
  if (!code) return
  let codeList = code.toString().split(',')
  let returnValue = []
  store.state.common.tags.map(item => {
    codeList.map(item1 => {
      if (item.id == item1) {
        returnValue.push(item.tagName)
      }
    })
  })
  return returnValue.join(',')
})

//年级范围
Vue.filter('courseTypeFilter', code => {
  let returnValue = null
  store.getters.courseType.map(item => {
    if (item.value == code) {
      returnValue = item.code
    }
  })
  return returnValue
})

//课程分类
Vue.filter('classifyFilter', code => {
  let returnValue = ''

  store.state.common.tags.map(item => {
    if (item.id == code) {
      returnValue = item.tagName
    }
  })
  return returnValue
})

//课程分类
Vue.filter('gender', code => {
  return code == '1' ? '男' : code == '2' ? '女' : '未知'
})

//课程分类
Vue.filter('courseLevel', code => {
  return code == '1' ? '初级班' : code == '2' ? '中级班' : code == '3' ? '高级班' : ''
})

//星期中文过滤
Vue.filter('weekName', code => {
  if (!code) return ''
  let codeList = code.split(',')
  let weekNameList = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日']
  let weekName = []
  codeList.map(value => {
    weekName.push(weekNameList[parseInt(value) - 1])
  })
  return weekName.join()
})

//价格显示 /100
Vue.filter('price', val => {
  return val ? val / 100 : val
})
